export function getCountries(withDescriptions, isOnlyWithProvinces) {
    const url = `${FRONT_OFFICE_URL}Entities/GetCountries?withDescriptions=${withDescriptions}&isOnlyWithProvinces=${isOnlyWithProvinces}`;
    return $.post(url);
}

export function getDocumentTypes(countryId, withDescriptions) {
    const url = `${FRONT_OFFICE_URL}Entities/GetIPFTypes?countryId=${countryId}&withDescriptions=${withDescriptions}`;
    return $.post(url);
}

export function getOriginMeetUp(withDescriptions) {
    const url = `${FRONT_OFFICE_URL}Entities/GetOriginMeetUp?withDescriptions=${withDescriptions}`;
    return $.post(url);
}

export function getCitiesSearch(idCountry, textSearch, withDescriptions) {
    const url = `${FRONT_OFFICE_URL}Entities/GetCitiesSearch?idCountry=${idCountry}&textSearch=${textSearch}&withDescriptions=${withDescriptions}`;
    return $.post(url);
}

export function getWorkstations(withDescriptions) {
    const url = `${FRONT_OFFICE_URL}Entities/GetWorkstations?withDescriptions=${withDescriptions}`;
    return $.post(url);
}